module.exports = __webpack_public_path__ + "2f7d95a3a3b45d1132cbd1e092dcedd3.MP3";